import React, { useState, useEffect } from 'react';
import {useAuthState} from 'react-firebase-hooks/auth'
import { auth } from '../config/firebase';
import { sendMessagetoOpenAI } from '../config/openai';
import ImageSearch from '../components/ImageSearch';
import { Typography , Button , Stack, TextField , Box} from "@mui/material"
import { Login } from './login';

export const Main = () => {
  const [user] = useAuthState(auth);
  const [input, setInput] = useState("");
  const [ideaResponse, setIdearesponse] = useState("");
  

  
  const handleSend = async() => {
    const response = await sendMessagetoOpenAI(input);
    setIdearesponse(response);
  };
  
  if (!user) {
    return (
      <Box paddingTop={6} sx={{ minHeight: "80vh" }}>
        <Login />

      </Box>
    );
  }


 
  return (
    <Box paddingX={4} paddingY={12} sx={{ minHeight: "100vh" }}>
      <Stack spacing={4} sx={{ alignItems: "center" }}>
        {/*
      {user?.photoURL &&  <img src={user?.photoURL} />}

  */}
        <Typography variant="h3" textAlign="center">
          Welcome {user?.displayName}
        </Typography>

        <Stack
          spacing={4}
          direction={{ xs: "column", sm: "row" }}
          sx={{ alignItems: "center" }}
        >
          <TextField
            label="Enter a topic"
            color="warning"
            helperText="For example: Web design services"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <Button variant="contained" color="warning" onClick={handleSend}>
            Suggest Idea{" "}
          </Button>
        </Stack>
      </Stack>
      {ideaResponse && <ImageSearch query={ideaResponse} />}
    </Box>
  );
  console.log(process.env.REACT_APP_OPENAI_API);
}

